import { render, staticRenderFns } from "./UserInvitationDataNew.vue?vue&type=template&id=c28942c8&scoped=true"
import script from "./UserInvitationDataNew.vue?vue&type=script&lang=ts"
export * from "./UserInvitationDataNew.vue?vue&type=script&lang=ts"
import style0 from "./UserInvitationDataNew.vue?vue&type=style&index=0&id=c28942c8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c28942c8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c28942c8')) {
      api.createRecord('c28942c8', component.options)
    } else {
      api.reload('c28942c8', component.options)
    }
    module.hot.accept("./UserInvitationDataNew.vue?vue&type=template&id=c28942c8&scoped=true", function () {
      api.rerender('c28942c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/invite/UserInvitationDataNew.vue"
export default component.exports